import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UiModule } from '@components/ui/ui-module';
import { BinderService } from '@services/binder.service';
import { NotificationService } from '@services/notification.service';
import { ScannerService } from '@services/scanner.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'lgb-scan-card',
  imports: [
    UiModule,
    CommonModule
  ],
  templateUrl: './scan-card.html',
  styleUrl: './scan-card.css',
})
export class ScanCard {
  readonly scanService=inject(ScannerService);
  readonly notify=inject(NotificationService);
  readonly success=signal(false);
  readonly loading=signal(false);
  readonly error=signal<string>(null);
  readonly enable=toObservable(this.scanService.enabled);

  constructor(){
    this.enable.subscribe(enabled => {
        this.success.set(false);
        this.error.set(null);
    });
  }

  scanPage(event: Event){
    this.scanAction('scan-page', event);
  }

  scanCard(event: Event){
    this.scanAction('scan-card', event);
  }

  refreshPage(event: Event){
    this.scanAction('refresh-page', event);
  }

  refreshCard(event: Event){
    this.scanAction('refresh-card', event);
  }

  scanAction(action: ActionType, event: Event){
    const input=event.target as HTMLInputElement;
    if(input.files && input.files.length){
      this.loading.set(true);
      let obs$: Observable<any>=null;
      switch(action){
        case 'scan-page':
          obs$=this.scanService.scanPageTotarget(input.files[0]);
          break;
        case 'refresh-page':
          obs$=this.scanService.refreshPageTotarget(input.files[0]);
          break;
        case 'scan-card':
          obs$=this.scanService.scanCardToTarget(input.files[0]);
          break;
        case 'refresh-card':
          obs$=this.scanService.refreshCardtoTarget(input.files[0]);
          break;
        default:
          break;
      }
      
      obs$.subscribe({
          next: page => {
            this.error.set(null);
            this.success.set(true);
            this.loading.set(false);
            input.value=null;
          },
          error: e => {
            this.error.set(e);
            this.loading.set(false);
            input.value=null;
          }
        });
    }
  }

  rmPage(){
    if(confirm('Voulez-vous supprimer cette page ?')){
      this.loading.set(true);
      this.scanService.rmPageTargert()
        .subscribe(result => {
          this.loading.set(false);
          this.notify.notifySuccess('Page supprimée.');
          this.back();
        });
    }
  }

  back(){
    this.scanService.disable();
  }
}

type ActionType='scan-page' | 'refresh-page' | 'scan-card' | 'refresh-card';
